import {Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'dmmp-error-page',
  templateUrl: './error-page.component.html'
})
export class ErrorPageComponent {
  @Input() data
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
}
